module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/1_0d6f5c8b14d26dc0ae6d3452d2c82ee7.png";